export default class Prompt {
	constructor(app) {
		this.view = null;
		this.result = null;
		this._app = app;
	}

	close() {
		this.view.close();
		this.view = null;
	}

	config(text) {
		const _ = this._app.getService("locale")._;
		return {
			view: "window",
			modal: true,
			move: true,
			width: 350,
			css: "webix_um_prompt",
			head: {
				view: "toolbar",
				padding: {
					left: webix.skin.$active.layoutPadding.form,
					right: webix.skin.$active.layoutPadding.form - 5,
				},

				borderless: true,
				cols: [
					{ view: "label", label: text },
					{
						view: "icon",
						icon: "wxi-close",
						hotkey: "esc",
						click: () => {
							this.result.reject("prompt cancelled");
							this.close();
						},
					},
				],
			},
			position: "center",
			body: {
				view: "form",
				padding: {
					top: webix.skin.$active.layoutPadding.form / 2,
					bottom: webix.skin.$active.layoutPadding.form,
				},
				cols: [
					{
						view: "text",
						name: "name",
						value: "",
					},
					{
						view: "button",
						value: _("Save"),
						css: "webix_primary",
						width: 100,
						hotkey: "enter",
						click: () => {
							const form = this.view.getBody();
							if (form.validate()) {
								const newname = form.getValues().name;
								this.result.resolve(newname);
								this.close();
							} else {
								webix.UIManager.setFocus(form);
							}
						},
					},
				],
			},
			on: {
				onShow() {
					const input = this.getBody().elements.name.getInputNode();
					input.focus();
				},
			},
		};
	}

	show(text) {
		this.result = new webix.promise.defer();
		this.view = webix.ui(this.config(text));
		webix.delay(() => this.view.show());
		return this.result;
	}
}
